/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const markedWhatsAppMessagesCountDataSchema = z.object({
	markedCount: z.number(),
})

export type MarkedWhatsAppMessagesCountDataSchema = z.infer<typeof markedWhatsAppMessagesCountDataSchema>
